// app/core/services/request-counter.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class RequestCounterService {
  private requestCount = 0;

  increment() {
    this.requestCount++;
  }

  decrement() {
    if (this.requestCount > 0) {
      this.requestCount--;
    }
  }

  hasPendingRequests(): boolean {
    return this.requestCount > 0;
  }
}
